import React from "react";
import { makeStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";

import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItemText from "@mui/material/ListItemText";

import IconButton from "@mui/material/IconButton";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";
import TimerOffIcon from "@mui/icons-material/TimerOff";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
}));

const CloseDateList = (props) => {
  const classes = useStyles();
  const [dense, setDense] = React.useState(false);
  
  const deleteCloseDateItem = (date) => {
    props.deleteCloseDateItem(date);
  };

  const sessionNames = (sessions) => {
    return sessions.map((session) => session.sessionName).join(", ");

  };

  return (
    <div className={classes.root}>
      {props.closeDaysItems && props.closeDaysItems.length > 0 ? (
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <Typography variant="h6" className={classes.title}>
            Close Dates
          </Typography>
          <div className={classes.demo}>
            <List dense={dense}>
              {props.closeDaysItems.map((item) => {
                return (
                  <ListItem key={item}>
                    <ListItemAvatar>
                      <TimerOffIcon />
                    </ListItemAvatar>
                    <ListItemText primary={item.date} secondary={sessionNames(item.sessions)}/>
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => deleteCloseDateItem(item)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </div>
        </Grid>
      ) : null}
    </div>
  );
};

export default CloseDateList;
